<template>
  <bk-page :loading="loading" @close="handleClose" pageType="navPage" :navBarInfo="navBarInfo" class="reviews-box">
    <!-- 添加评论 -->
    <bk-view class="reviews-Wrap" v-if="componentName == 'reviewsAdd'">
      <bk-view class="rate-view">
        <bk-view>
          <bk-rate v-model:value="score" size="24px"></bk-rate>
          <bk-view class="star-textContent">
            <bk-lang v-for="i in starLangCode" :key="i" :code="i"></bk-lang>
          </bk-view>
        </bk-view>
      </bk-view>

      <bk-view class="thoughts-view">
        <bk-view>
          <bk-lang code="orderReviews_thoughts"></bk-lang>
          <bk-input
            langCode_placeholder="orderReviews_thoughts_placeholder"
            showTextArea
            v-model:value="content"
          ></bk-input>
          <bk-upload preview-size="80px" :maxCount="10" v-model:modelValue="images"></bk-upload>
        </bk-view>
        <bk-button @click="handleAddReviews" langCode="orderReviews_add"></bk-button>
      </bk-view>
    </bk-view>

    <!-- 评论结果 -->
    <transition name="rightFadeIn">
      <bk-view class="view-successPage" v-if="componentName == 'reviewsResult'">
        <bk-image :src="imgUrl"></bk-image>
        <bk-view>
          <bk-lang code="ReviewsResult_content"></bk-lang>
        </bk-view>
      </bk-view>
    </transition>
  </bk-page>
  <bk-view class="view_google_reviews" v-if="showGoogleReviews">
    <bk-view class="google-close-btn" @click="handleCloseGoogleReview">
      <bk-icon icon="icon-fi-sr-cross-small" style="font-size: 24px"></bk-icon>
    </bk-view>
    <bk-view class="google-content">
      <bk-image class="google-banner" :src="$bk_getImageUrl('Def_Bg_orderReviews_googleReviews.png')"></bk-image>
      <bk-lang class="google-title" code="google_reviews_title"></bk-lang>
      <bk-text class="google-subtitle">
        {{ $bk_replaceVAR('google_reviews_subtitle', reviewBoosterSetting?.compName || '') }}
      </bk-text>
      <bk-view class="google-review-card">
        <bk-view class="google-stars">
          <bk-rate :value="score" size="24px"></bk-rate>
          <bk-view class="star-textContent">
            <bk-lang v-for="i in starLangCode" :key="i" :code="i"></bk-lang>
          </bk-view>
        </bk-view>
        <bk-view class="google-review-text">
          <bk-text>{{ content }}</bk-text>
        </bk-view>
        <bk-button class="copy-btn" @click="handleCopyReview" langCode="google_reviews_copy_btn"></bk-button>
      </bk-view>
    </bk-view>
    <bk-view class="google-footer">
      <bk-button
        class="continue-btn"
        @click="handleContinueToGoogle"
        langCode="google_reviews_continue_btn"
      ></bk-button>
    </bk-view>
  </bk-view>
</template>

<script>
	import { billReq, customerReq, shopReq } from '@/reqService';

	import { starLangCode } from './dataSource';

	export default {
		name: 'orderReviews',
		computed: {
			navBarInfo () {
				return {
					backFlag: true,
					langCode_title: this.titleCode,
				};
			},
		},
		data () {
			this.starLangCode = starLangCode;
			return {
				id: '',
				score: 5,
				content: '',
				images: [],
				// 收银单详情
				resInfo: {},
				componentName: 'reviewsAdd',
				titleCode: 'orderReviews_title1',
				showGoogleReviews: false,
				imgUrl: '',
				loading: false,
				// 谷歌评价提升设置
				reviewBoosterSetting: null,
			};
		},
		created () {
			let imgUrl = 'Def_Bg_reviewsSuccess.png';

			if (window.oblissDZFlag) {
				imgUrl = 'Def_Bg_healthy_reviewsSuccess.png';
			}

			if (window.komoDZFlag) {
				imgUrl = 'Def_Bg_Komo_reviewsSuccess.png';
			}

			this.imgUrl = this.$bk_getImageUrl(imgUrl);
		},
		methods: {
			handleClose () {
				if (typeof window.showReserve == 'function' && this.componentName == 'reviewsResult') {
					if (this.resInfo && this.resInfo.compId) {
						window.showReserve({
							resShopInfo: { ...this.resInfo, id: this.resInfo.compId },
							resItemInfo: undefined,
							activeTabKey: 'reviewsShow',
						});
					}
				}
				this.$router.replace('/appointments');
			},
			// 获取收银单详情
			async requestGetOrderInfoById () {
				// 根据路由参数billId获取账单详情，拿到所需的参数门店id，单据编号
				this.id = this.$route.params?.billId;
				if (!this.id) {
					return;
				}
				this.loading = true;
				let res = await billReq.requestGetOrderInfoById(this, { id: this.id }).finally(() => {
					this.loading = false;
				});
				this.resInfo = res;
			},
			parseParams () {
				const { content, score, resInfo, images, id } = this;
				const { custId, compId, billNo, memberId, memberName, billEmployeeList } = resInfo || {};
				let data = {
					custId,
					compId,
					billId: id,
					billNo,
          ...(memberId && { memberId }),
          ...(memberName && { memberName }),
					content,
					score,
					images: (images || [])
						.map((item) => {
							return item.url;
						})
						.join(','),

					itemList: (billEmployeeList || []).map((employee) => {
						return {
							goodsName: '',
							goodsCode: '',
							empId: employee.employeeId,
							empName: employee.name,
							empCode: employee.employeeTypeId,
						};
					}),
				};
				return data;
			},
			// 提交评论
			async handleAddReviews () {
				if (this.content.trim() === '') {
					this.$bk_message.error({ langCode: 'orderReviews_addEmptyPrompt' });
					return;
				} else {
					const data = this.parseParams();
					this.loading = true;
					const res = await customerReq.requestPostMemberReviews(this, data).finally(() => {
						this.loading = false;
					});
					if (res) {
						// 检查是否需要弹出谷歌评价
						await this.checkAndShowGoogleReviews();
						// 结果页
						this.componentName = 'reviewsResult';
						this.titleCode = 'orderReviews_title2';
					}
					return;
				}
			},
			// 检查并显示谷歌评价弹窗
			async checkAndShowGoogleReviews () {
				try {
					const compId = this.resInfo?.compId;
					if (!compId) {
						return;
					}
					// 获取谷歌评价提升设置
					const setting = await shopReq.requestGetReviewBoosterSetting(this, compId);
					if (!setting || setting.status !== 1 || !setting.googleReviewLink) {
						return;
					}
					this.reviewBoosterSetting = setting;
					// 根据后台配置的reviewTrigger判断是否符合条件
					// reviewTrigger: 5-仅限5星, 4-4星及以上, 3-3星及以上, 2-2星及以上, 0-所有评价
					const reviewTrigger = setting.reviewTrigger;
					const currentScore = this.score;
					let shouldShowGoogleReview = false;
					if (reviewTrigger === 0) {
						// 所有评价都弹窗
						shouldShowGoogleReview = true;
					} else if (reviewTrigger >= 2 && reviewTrigger <= 5) {
						// N星及以上
						shouldShowGoogleReview = currentScore >= reviewTrigger;
					}
					if (shouldShowGoogleReview) {
						this.showGoogleReviews = true;
					}
				} catch (error) {
					console.error('获取谷歌评价提升设置失败:', error);
				}
			},
			// 关闭Google评论弹窗
			handleCloseGoogleReview () {
				this.showGoogleReviews = false;
			},
			// 复制评论内容
			handleCopyReview () {
				if (this.content) {
					this.$bk_copyToPasteBoard(this.content);
				}
			},
			// 跳转到Google评论
			handleContinueToGoogle () {
				const url = this.reviewBoosterSetting?.googleReviewLink;
				if (!url) {
					return;
				}
				this.$bk_nativeOpenSystemBrowser(url, '_blank');
				this.showGoogleReviews = false;
			},
		},
		mounted () {
			let token = this.$bk_getAccessToken();

			if (!token || token == '') {
				let that = this;
				window.viewCallback = function () {
					that.requestGetOrderInfoById();
				};
				return;
			}
			this.requestGetOrderInfoById();
		},
	};
</script>

<style lang="less" scoped>
  @import './orderReviews.less';
</style>
